import { api } from './api'
import { throwApiError } from './apiHelpers'

function assertSuccess(body: { success?: boolean; message?: string; data?: unknown }) {
  if (!body?.success) {
    const err = new Error(body?.message || 'Request failed') as Error & { code?: string }
    err.code = (body as { error?: { code?: string } }).error?.code
    throw err
  }
  return body.data
}

export type AdminStripeConnectStatus = {
  storeId: number
  connectAccountId: string | null
  chargesEnabled: boolean
  payoutsEnabled: boolean
  detailsSubmitted: boolean
  autoWithdraw: 'off' | 'daily' | 'weekly' | 'monthly'
  autoWithdrawAnchorAt: string | null
  readyForCheckout: boolean
  currencyEligible: boolean
  stripeConfigured: boolean
}

export async function getStoreStripeConnect(
  storeId: number | string,
): Promise<AdminStripeConnectStatus> {
  try {
    const { data } = await api.get(`/admin/stores/${encodeURIComponent(String(storeId))}/stripe/connect`)
    return assertSuccess(data) as AdminStripeConnectStatus
  } catch (e) {
    throwApiError(e, 'Failed to load Stripe Connect status')
  }
}

export async function createStoreStripeConnectAccountLink(
  storeId: number | string,
): Promise<{ url: string; connectAccountId: string }> {
  try {
    const { data } = await api.post(
      `/admin/stores/${encodeURIComponent(String(storeId))}/stripe/connect/account-link`,
    )
    return assertSuccess(data) as { url: string; connectAccountId: string }
  } catch (e) {
    throwApiError(e, 'Failed to create Stripe onboarding link')
  }
}
